import { getLoginDataHelper } from '_controllers/helpers/getLoginData';
import { useContext, useState } from 'react';
import { LayoutContext } from '../data/layoutContext';

export const useLayoutMenuList = () => {
  const { userPermissions } = getLoginDataHelper();

  const layoutContext = useContext(LayoutContext) || {};
  const { layoutVariables, methods } = layoutContext || {};

  const {
    activeStyle,
    open,
    openMenuSupport,
    openMenuSales,
    openMenuMarketing,
    openMenuManager,
    openSaleTransfer,
    paymentSuppliers,
    openMenuReportsSales,
    openMenuReportsPortability,
    openMenuReportsLines,
    openMenuReportsIft,
    openMenuAccounting,
    openShipping,
    openMenuMTCenter,
    openLineAssignments,
  } = layoutVariables || {};

  const { layoutMethods } = methods || {};

  const {
    handleClickShipping,
    handleClickSupport,
    handleClickMarketing,
    handleClickManager,
    handleOpenSaleTransfer,
    handleClickReportsSales,
    handleClickReportsLines,
    handleClickReportsPortability,
    handleClickReportsIft,
    handleClickSales,
    handleClickMenuAccounting,
    handleOpenSuppliers,
    handleOpenMTCenter,
    handleClickLineAssignments,
  } = layoutMethods || {};

  // Solo una variable de estado para todos los popovers
  const [popover, setPopover] = useState({ name: null, anchorEl: null });

  const handlePopoverOpen = (name) => (event) => {
    if (!open) setPopover({ name, anchorEl: event.currentTarget });
  };
  const handlePopoverClose = () => setPopover({ name: null, anchorEl: null });

  // Helpers para saber cuál está abierto
  const isPopoverOpen = (name) => popover.name === name;

  const header = {
    support: { kind: 'header', title: 'Atención a clientes' },
    sales: { kind: 'header', title: 'Ventas' },
    accounting: { kind: 'header', title: 'Contabilidad' },
    marketing: { kind: 'header', title: 'Marketing' },
    reports: { kind: 'header', title: 'Reportes' },
    transactions: { kind: 'header', title: 'Transacciones de pago' },
    directory: { kind: 'header', title: 'OMVs' },
    lines: { kind: 'header', title: 'Vinculación de líneas' },
  };

  return {
    activeStyle,
    open,
    openMenuSupport,
    openMenuSales,
    openMenuMarketing,
    openMenuManager,
    openSaleTransfer,
    paymentSuppliers,
    openMenuReportsSales,
    openMenuReportsLines,
    openMenuReportsPortability,
    openMenuMTCenter,
    openMenuAccounting,
    openShipping,
    openLineAssignments,

    openMenuReportsIft,

    handleClickShipping,
    handleClickSupport,
    handleClickMarketing,
    handleClickManager,
    handleOpenSaleTransfer,
    handleClickReportsSales,
    handleClickReportsLines,
    handleClickReportsPortability,
    handleClickSales,
    handleClickMenuAccounting,
    handleOpenSuppliers,
    userPermissions,
    handleOpenMTCenter,
    handleClickLineAssignments,

    handleClickReportsIft,

    // Popover general
    handlePopoverOpen,
    handlePopoverClose,
    isPopoverOpen,
    popoverAnchorEl: popover.anchorEl,

    header,
  };
};
